import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import SideBarItem from "./Sidebar-item";

import "./Sidebar.css";
import LogoutIcon from "../../assets/icons/logout.svg";

function SideBar({ menu }) {
  const location = useLocation();
  const [active, setActive] = useState(() => {
    // 페이지 로드 시 localStorage에서 active 값을 가져옵니다.
    const storedActive = localStorage.getItem("active");
    // 저장된 값이 있는 경우에는 해당 값을, 없는 경우에는 기본 값 1을 사용합니다.
    return storedActive ? Number(storedActive) : 1;
  });

  // localStorage의 auth 값 확인
  const userAuth = localStorage.getItem("auth");

  // 메뉴 필터링: Superadmin이면 auth가 "Superadmin"인 메뉴만, auth가 없으면 모두 표시
  const filteredMenu = menu.filter((item) => {
    if (!item.auth) return true; // 메뉴에 auth가 없으면 누구나 볼 수 있음
    if (userAuth === "Superadmin" && item.auth === "Superadmin") return true;
    if (userAuth === "Admin" && item.auth === "Admin") return true;
    return false;
  });

  useEffect(() => {
    menu.forEach((element) => {
      // '/admin/'을 path에 추가하여 비교
      if (location.pathname === `/admin/${element.path}`) {
        setActive(element.id);
        // active 값을 localStorage에 저장합니다.
        localStorage.setItem("active", element.id.toString());
      }
    });
  }, [location.pathname]);

  const __navigate = (id) => {
    setActive(id);
    // active 값을 클릭한 메뉴의 ID로 업데이트하고 localStorage에 저장합니다.
    localStorage.setItem("active", id.toString());
  };

  // 로그아웃 함수
  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("auth");
    // localStorage에서 active 값을 제거합니다.
    localStorage.removeItem("active");
    localStorage.removeItem("userid");
    localStorage.removeItem("id");
    window.location.reload();
  };

  return (
    <nav className="sidebar">
      <div className="sidebar-container">
        <div className="sidebar-logo-container">
          <div className="text-wrap">
            <span>Smart Doctor</span>
            <span>Admin</span>
            <span>System</span>
          </div>
          {/* <div className='access-info-container'>
            <span className='access-user-info'><img src={UserIcon} />{localStorage.getItem('userid')}님, 안녕하세요.</span>
          </div> */}
        </div>

        <div className="sidebar-container">
          <div className="sidebar-items">
            {filteredMenu.map((item, index) => (
              <div key={item.id} onClick={() => (item.path ? __navigate(item.id) : item.onClick())}>
                {/* {index === 4 && <div className='sidebar-divider'></div>} */}
                <SideBarItem active={item.id === active} item={item} />
              </div>
            ))}
          </div>

          <div className="sidebar-footer" onClick={handleLogout}>
            <div className="logout-container">
              <span className="sidebar-item-label">Logout</span>
              <img src={LogoutIcon} alt="icon-logout" className="sidebar-item-icon" />
            </div>
            {/* <div className="access-info"><FontAwesomeIcon icon={faClock} />&nbsp;{formatAccessWbar(new Date())}</div> */}
          </div>
        </div>
      </div>
    </nav>
  );
}

export default SideBar;
